import type { Language } from './types';

export type Messages = Record<string, any>;

// Dynamic locale loader – each language becomes its own chunk
export async function loadLocale(lang: Language): Promise<Messages> {
  switch (lang) {
    case 'en':
      return (await import('./translations/locales/en')).default;
    case 'es':
      return (await import('./translations/locales/es')).default;
    case 'fr':
      return (await import('./translations/locales/fr')).default;
    case 'de':
      return (await import('./translations/locales/de')).default;
    case 'pt':
      return (await import('./translations/locales/pt')).default;
    case 'zh':
      return (await import('./translations/locales/zh')).default;
    case 'ja':
      return (await import('./translations/locales/ja')).default;
    case 'ru':
      return (await import('./translations/locales/ru')).default;
    default:
      return (await import('./translations/locales/en')).default;
  }
}

export async function preloadLocales(langs: Language[]): Promise<Record<Language, Messages>> {
  const entries = await Promise.all(
    langs.map(async (l) => [l, await loadLocale(l)] as [Language, Messages])
  );
  return Object.fromEntries(entries) as Record<Language, Messages>;
}
